// Generated by Claude Code
import { createFileRoute } from '@tanstack/react-router'
import { MetersSettingsPage } from '#components/domain/operations/meters/settings/meters-settings-page.tsx'

export const Route = createFileRoute('/_appSettings/$companyId/settings/meters')({
  component: MetersSettingsPage,
})
